import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginModal from "./loginModal";
import { Mail, PhoneCall, SquareUser } from "lucide-react";

const Header = () => {

  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className="">
      <div className="bg-black flex text-white gap-2 p-2">
        <span className="text-white ml-3">  <Mail size={20} /> </span>  <span > info@isure.in</span>
        <span className="text-white ml-3">  <PhoneCall size={20} /> </span>  <span > +91 8765675432</span>
      </div>
      <header className="bg-white text-black p-2 d-flex justify-content-between align-items-center overflow-hidden ">
        <div className="d-flex align-items-center">
          <img src="/images/final_Logo_Image.jpeg" alt="ISure Logo" style={{ height: "7rem", width: '100%' }} />
        </div>
        <div >
          <a href="#pricing" className="text-black me-3">Pricing</a>
          
          <a href="/contact" className="text-black">Contact</a>
          <button
            className=" backButton ms-3 d-inline-flex align-items-center gap-1"
            onClick={() => setModalOpen(true)}
          >
            <SquareUser color="white" size={20} />
            <span>Sign In</span>
          </button>

        </div>
        <LoginModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      </header>
    </div>
  );
};


export default Header;
